import { v4 as uuidv4 } from 'uuid';
export class SecurityRightModel {
    constructor() {
        this.id = uuidv4();
        this.securityRightDefinition = '';
    }
}
export class Right extends SecurityRightModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
